export default "__VITE_ASSET__79495327__"